import { render, staticRenderFns } from "./genel.vue?vue&type=template&id=6bc85b9c&"
import script from "./genel.vue?vue&type=script&lang=js&"
export * from "./genel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports